import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  heading: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.labraText.primary,
  },
}))
